import React from "react";
import styled from "styled-components";
import { Trans } from "react-i18next";

import { Link } from "@mui/material";

const TermsofUseLink = styled(Link) <{ $size?: "small" | "default"; $textDecoration?: "underline" | "none" }>`
    &&& {
        font-family: "Source Sans Pro";
        font-size: ${({ $size }) => $size === "small" ? "11px" : "12px"};
        font-style: normal;
        font-weight: 400;
        line-height: ${({ $size }) => $size === "small" ? "125%" : "145%"};
        letter-spacing: ${({ $size }) => $size === "small" ? "normal" : "-0.28px"};
        text-decoration-line: ${({ $size, $textDecoration }) => $textDecoration ? $textDecoration : $size === "small" ? "none" : "underline"};
        color: #11a9e2;
    }
`;

interface TermsOfUseAndRefundPolicyProps {
    size?: "small" | "default";
    textDecoration?: "underline" | "none";
}

export function TermsOfUseAndRefundPolicy({ size = "default", textDecoration = "underline" }: TermsOfUseAndRefundPolicyProps) {
    return (
        <span>
            <Trans
                i18nKey="<terms>Terms of Service</terms> and <refund>Refund Policy</refund>."
                components={{
                    terms: (
                        <TermsofUseLink
                            $size={size}
                            $textDecoration={textDecoration}
                            target="_blank"
                            href="https://www.beautiful.ai/terms-of-service"
                        />
                    ),
                    refund: (
                        <TermsofUseLink
                            $size={size}
                            $textDecoration={textDecoration}
                            target="_blank"
                            href="https://support.beautiful.ai/hc/en-us/articles/360030719012-What-is-your-refund-policy"
                        />
                    )
                }}
            />
        </span>
    );
}
